import axios from 'axios';
import getTokens from './getTokens';
import { mustOut } from '../redux/actions/AuthenticationActions';

import { store } from '../index';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_X_API_KEY,
    wcToken: getTokens().wcToken(),
    wcTrustedToken: getTokens().wcTrustedToken(),
    ripleyToken: getTokens().ripleyToken(),
    ripleyRefreshToken: getTokens().ripleyRefreshToken(),
    wcUserActivity: getTokens().wcUserActivity(),
    wcPersistent: getTokens().wcPersistent(),
    wcSessionCustomer: getTokens().wcSessionCustomer(),
    wcActivePointer: getTokens().wcActivePointer(),
    wcSessionEstablished: getTokens().wcSessionEstablished(),
  },
});

const onResponseSuccess = (response) => response;

const onResponseFail = (error) => {
  const status = error.status || error.response.status;
  if (status === 401) store.dispatch(mustOut());
  return error.response;
};

axiosInstance.interceptors.response.use(onResponseSuccess, onResponseFail);

export default axiosInstance;
